document.addEventListener('DOMContentLoaded', () => {
  const themeToggle = document.querySelector('.theme-toggle');
  if (themeToggle) {
    themeToggle.addEventListener('click', () => {
      let currentTheme = document.documentElement.classList.contains('dark-mode') ? 'dark' : 'light';
      let newTheme = currentTheme === 'dark' ? 'light' : 'dark';

      document.documentElement.classList.remove(currentTheme + '-mode');
      document.documentElement.classList.add(newTheme + '-mode');

      try {
        localStorage.setItem('shopify-theme-mode', newTheme);
      } catch (e) {
        console.error("Failed to save theme preference to localStorage:", e);
      }

      // Dispatch a custom event for other components to react to theme changes
      const event = new CustomEvent('theme:change', { detail: { theme: newTheme } });
      document.dispatchEvent(event);
    });
  }
});
